export default __webpack_public_path__ + "static/media/call-to-action-01-macbook.de4cc18b.png";